'use client';

import { Card, Label } from '@repo/ui';
import { ScrollableContainer } from '../common/scrollable-container';
import { DistributionGraph } from '../common/distribution-graph';
import { PercentileResult } from '../../../lib/stats/percentile';

interface PercentileCalculatorProps {
  visualizationData: PercentileResult | null;
}

export function PercentileCalculator({ visualizationData: result }: PercentileCalculatorProps) {
  if (!result) {
    return null;
  }

  const percentileLabels = [
    { value: result.percentiles.p25, label: '25th', color: '#4CAF50' },
    { value: result.percentiles.p50, label: '50th', color: '#2196F3' },
    { value: result.percentiles.p75, label: '75th', color: '#9C27B0' },
    { value: result.percentiles.p90, label: '90th', color: '#FF9800' },
    { value: result.percentiles.p95, label: '95th', color: '#F44336' },
    { value: result.percentiles.p99, label: '99th', color: '#795548' }
  ];

  return (
    <ScrollableContainer>
      <div className="space-y-6">
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Percentile Results</h3>
          <div className="grid grid-cols-2 gap-4">
            {percentileLabels.map(({ value, label, color }) => (
              <div key={label}>
                <Label>{label} Percentile</Label>
                <div className="text-lg font-semibold" style={{ color }}>
                  {value.toFixed(2)}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4">
            <Label>Interpretation</Label>
            <div className="text-sm text-muted-foreground">{result.interpretation}</div>
          </div>
        </Card>

        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Distribution Plot</h3>
          <DistributionGraph
            data={result.data}
            height={300}
            labels={percentileLabels.map(({ value, label, color }) => ({
              value,
              text: `P${label}`,
              color
            }))}
            grid={{
              left: '15%',
              right: '5%',
              top: '10%',
              bottom: '15%'
            }}
          />
        </Card>
      </div>
    </ScrollableContainer>
  );
} 